<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]" style="width: 1000px; max-width: 96vw;">
    <q-form ref="form" @submit="this.onSubmit">
      <div class="form-section">
        <h3 class="form-section__title">Основная информация</h3>
        <div class="form">
          <div class="form__item" ref="provider_name_ref">
            <CustomInput label="Юридическое наименование" type="text" :required="true"
              :value="this.formData.provider_name" @change_input="(value) => onChange('provider_name', value)" />
          </div>

          <div class="form__item" ref="director_fio_ref">
            <CustomInput label="Полное ФИО Директора" type="text" :required="true" :value="this.formData.director_fio"
              @change_input="(value) => onChange('director_fio', value)" />
          </div>

          <!-- Поле ГУИД скрыто по требованию -->

          <div class="form__item" ref="bin_ref">
            <CustomInput label="БИН" type="text" :required="true" :value="this.formData.bin"
              @change_input="(value) => onChange('bin', value)" />
          </div>

          <div class="form__item" ref="contract_text_type_id_ref">
            <CustomSelect
              :options="contractTextTypeOptionsWithCurrent"
              label="Действующий на основании"
              optionValueKey="contract_text_type_id"
              optionLabelKey="contract_text_type_name"
              :value="this.formData.contract_text_type_id || ''"
              @change="(value) => onContractTextTypeChange(value)"
              :required="true"
              :clearable="false"
            />
          </div>

          <template v-if="showActingBasisDocumentFields">
            <div class="form__item">
              <CustomInput
                :label="actingBasisDocumentNumberLabel"
                type="text"
                :value="this.formData.acting_basis_document_number"
                placeholder="Например: БН-123"
                @change_input="(value) => onChange('acting_basis_document_number', value)"
              />
            </div>

            <div class="form__item">
              <CustomDate
                :fullWidth="true"
                :label="actingBasisDocumentDateLabel"
                :value="this.formData.acting_basis_document_date"
                placeholder="Например: 04.09.2025"
                @change_date="(value) => onChange('acting_basis_document_date', value)"
              />
            </div>
          </template>

        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Интеграция</h3>
        <div class="form">
          <div class="form__item form__item--full">
            <CustomInputDropdown :options="partnerSBSOptions" label="Поставщик SBS (поиск по БИН или по наименованию)"
              @change_input="(val) => this.partnerSBSFilterFunc(val)" optionValueKey="sbs_partner_id"
              optionLabelKey="naimenovanie" :value="this.formData.sbs_partner_name || ''"
              :loading="this.partnerSBSLoading" @select_item="this.partnerSBSSelectItem" />
          </div>

          <div class="form__item" ref="sbs_snr_id_ref">
            <CustomSelect :options="sbsSnrOptions" label="Режим налогообложения (СНР)"
              optionValueKey="sbs_spetsialnye_nalogovye_rezhimy_id" optionLabelKey="naimenovanie"
              :value="this.formData.sbs_snr_id || ''" @change="(value) => onChange('sbs_snr_id', value)"
              :required="false" />
          </div>

          <div class="form__item" ref="sbs_vidy_deyatelnosti_id_ref">
            <CustomSelect :options="availableOkedyOptionsForSelect" label="ОКЕД (вид деятельности)"
              :filterFunc="showMultipleOkedyWarning ? null : this.sbsVidyDeyatelnostiFilterFunc" optionValueKey="sbs_vidy_deyatelnosti_id"
              optionLabelKey="display_name" :value="this.formData.sbs_vidy_deyatelnosti_id || ''"
              :loading="this.sbsVidyDeyatelnostiLoading" @change="this.sbsVidyDeyatelnostiChange" :required="false" />
            <div v-if="showMultipleOkedyWarning" class="okedy-warning-text">
              У Поставщика SBS указано несколько видов деятельности. Выберите одну из них.
            </div>
          </div>

          <div class="form__item">
            <CustomInput
              label="Комментарий по СНР"
              type="textarea"
              :value="this.formData.sbs_avto_link_comment_snr"
              :disable="true"
              placeholder=" "
            />
          </div>

          <div class="form__item">
            <CustomInput
              label="Комментарий по видам деятельности"
              type="textarea"
              :value="this.formData.sbs_avto_link_comment_vidy_deyatelnosti"
              :disable="true"
              placeholder=" "
            />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Адрес и контакты</h3>
        <div class="form">
          <div class="form__item" ref="contragent_country_id_ref">
            <CustomSelect :options="countryOptions" label="Страна резидентства" :required="true"
              optionValueKey="contragent_country_id" optionLabelKey="country_name"
              :value="this.formData.contragent_country_id || ''"
              @change="(value) => onChange('contragent_country_id', value)" />
          </div>

          <div class="form__item" ref="city_id_ref">
            <CustomSelect :options="cityOptions" label="Бизнес регион" :required="true" optionValueKey="city_id"
              optionLabelKey="city_name" :value="this.formData.city_id || ''"
              @change="(value) => onChange('city_id', value)" />
          </div>

          <div class="form__item" ref="address_ref">
            <CustomInput label="Адрес" type="textarea" :required="true" :value="this.formData.address"
              @change_input="(value) => onChange('address', value)" />
          </div>

          <div class="form__item" ref="phone_ref">
            <CustomInput label="Телефон" type="text" :required="true" :value="this.formData.phone"
              @change_input="(value) => onChange('phone', value)" />
          </div>

          <div class="form__item" ref="provider_email_ref">
            <CustomInput label="Email" type="email" :value="this.formData.provider_email"
              @change_input="(value) => onChange('provider_email', value)" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Типы и классификация</h3>
        <div class="form">
          <div class="form__item">
            <CustomSelect :options="contragentTypeOptions" label="Тип контрагента"
              optionValueKey="contragent_type_id"
              optionLabelKey="contragent_type_name" :value="this.formData.contragent_type_id || ''"
              @change="(value) => onChange('contragent_type_id', value)" />
          </div>

          <div class="form__item">
            <CustomSelect :options="providerTypeOptions" label="Тип поставщика"
              optionValueKey="provider_type_id"
              optionLabelKey="provider_type_name" :value="this.formData.provider_type_id || ''"
              @change="(value) => onChange('provider_type_id', value)" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Банковские реквизиты</h3>
        <div class="form">
          <div class="form__item" ref="iik_ref">
            <CustomInput label="ИИК" type="text" :value="this.formData.iik"
              @change_input="(value) => onChange('iik', value)" :required="true" />
          </div>

          <div class="form__item" ref="bank_name_ref">
            <CustomInput label="Наименование банка" type="text" :value="this.formData.bank_name"
              @change_input="(value) => onChange('bank_name', value)" :required="true" />
          </div>

          <div class="form__item" ref="bik_ref">
            <CustomInput label="БИК" type="text" :value="this.formData.bik"
              @change_input="(value) => onChange('bik', value)" :required="true" />
          </div>

          <div class="form__item" ref="kbe_ref">
            <CustomInput label="КБе" type="number" :value="this.formData.kbe"
              @change_input="(value) => onChange('kbe', value)" :required="true" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Настройки и параметры</h3>
        <div class="form">
          <!-- Запрет на создание автоматических платежей скрыт -->

          <div class="form__item">
            <CustomCheckbox label="Плательщик НДС" :value="this.formData.is_nds" :binary="true"
              @change="(value) => onChange('is_nds', value)" />
          </div>

          <!-- Маржа материала скрыта -->
          <!-- Показывать цену до скидки скрыто -->
          <!-- Автоматическая отправка заявок по ГПР скрыта -->

          <div class="form__item">
            <CustomCheckbox label="Подписка на рассылку" :value="this.formData.is_subscribe" :binary="true"
              @change="(value) => onChange('is_subscribe', value)" />
          </div>

          <div class="form__item">
            <CustomCheckbox label="Доставка в субботу" :value="this.formData.is_saturday_delivery" :binary="true"
              @change="(value) => onChange('is_saturday_delivery', value)" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Дополнительная информация</h3>
        <div class="form">
          <div class="form__item form__item--full">
            <CustomInput label="Комментарий" type="textarea" :value="this.formData.comment"
              @change_input="(value) => onChange('comment', value)" />
          </div>
        </div>
      </div>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomDate from "@/components/form/CustomDate";
import { getCity, getProviderCountry, getContragentType, getProviderType, mapSBSVidyDeyatelnosti, getSBSsnr } from "@/views/Providers/services";
import { mapSBSPartner, getContractTextType } from "@/views/Contractors/services";
import CustomInputDropdown from "@/components/form/CustomInputDropdown";

export default {
  name: "add-handbook-provider",
  components: { CustomCheckbox, CustomModalFooter, CustomInput, CustomSelect, CustomInputDropdown, CustomDate },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        is_not_create_auto_payment: this.data?.body?.is_not_create_auto_payment || false,
        provider_name: this.data?.body?.provider_name || '',
        material_marzha: this.data?.body?.material_marzha || '',
        is_nds: this.data?.body?.is_nds || 0,
        director_fio: this.data?.body?.director_fio || '',
        guid: this.data?.body?.guid || '',
        bin: this.data?.body?.bin || '',
        address: this.data?.body?.address || '',
        city_id: this.data?.body?.city_id || '',
        provider_type_id: this.data?.body?.provider_type_id || '',
        contragent_type_id: this.data?.body?.contragent_type_id || '',
        iik: this.data?.body?.iik || '',
        bank_name: this.data?.body?.bank_name || '',
        bik: this.data?.body?.bik || '',
        kbe: this.data?.body?.kbe || '',
        contract_text: this.data?.body?.contract_text || '',
        contract_text_type_id: this.data?.body?.contract_text_type_id || '',
        acting_basis_document_number: this.data?.body?.acting_basis_document_number || '',
        acting_basis_document_date: this.data?.body?.acting_basis_document_date || '',
        phone: this.data?.body?.phone || '',
        provider_email: this.data?.body?.provider_email || '',
        comment: this.data?.body?.comment || '',
        is_show_old_price: this.data?.body?.is_show_old_price || 0,
        is_subscribe: this.data?.body?.is_subscribe || 0,
        is_auto_gpr: this.data?.body?.is_auto_gpr || 0,
        is_saturday_delivery: this.data?.body?.is_saturday_delivery || 0,
        sbs_partner_id: this.data?.body?.sbs_partner_id || '',
        sbs_partner_name: this.data?.body?.sbs_partner_name || '',
        sbs_vidy_deyatelnosti_id: this.data?.body?.sbs_vidy_deyatelnosti_id || '',
        display_name: this.data?.body?.display_name || '',
        sbs_snr_id: this.data?.body?.sbs_snr_id || '',
        naimenovanie: this.data?.body?.naimenovanie || '',
        sbs_avto_link_comment_snr: this.data?.body?.sbs_avto_link_comment_snr || '',
        sbs_avto_link_comment_vidy_deyatelnosti: this.data?.body?.sbs_avto_link_comment_vidy_deyatelnosti || '',
      },
      cityOptions: [],
      sbsVidyDeyatelnostiOptions: [],
      sbsVidyDeyatelnostiLoading: false,
      showMultipleOkedyWarning: false,
      availableOkedyOptionsFromPartner: [],
      hasMultipleOkedyFromPartner: false,
      countryOptions: [],
      contragentTypeOptions: [],
      providerTypeOptions: [],
      partnerSBSOptions: [],
      partnerSBSLoading: false,
      sbsSnrOptions: [],
      contractTextTypeOptions: [],
    }
  },
  computed: {
    // Добавляем текущее значение в список опций, если его там нет
    contractTextTypeOptionsWithCurrent() {
      const options = [...this.contractTextTypeOptions];

      // Если есть contract_text и он не найден в списке опций, добавляем его
      if (this.formData.contract_text && !this.isContractTextInOptions) {
        // Создаем временную опцию для текущего значения
        // Используем отрицательный ID, чтобы отличить от реальных опций
        const tempOption = {
          contract_text_type_id: `temp_${this.formData.contract_text}`,
          contract_text_type_name: this.formData.contract_text,
          isTemporary: true
        };
        options.unshift(tempOption);
      }

      return options;
    },
    // Проверяем, найден ли текущий contract_text в списке опций
    isContractTextInOptions() {
      if (!this.formData.contract_text || !this.contractTextTypeOptions.length) {
        return false;
      }
      return this.contractTextTypeOptions.some(
        option => option.contract_text_type_name === this.formData.contract_text
      );
    },
    // Выбранная опция "Действующий на основании"
    selectedContractTextType() {
      if (!this.formData.contract_text_type_id) return null;
      return this.contractTextTypeOptionsWithCurrent.find(
        opt => opt.contract_text_type_id === this.formData.contract_text_type_id ||
          String(opt.contract_text_type_id) === String(this.formData.contract_text_type_id)
      );
    },
    // Показывать ли поля номера и даты (для доверенности/талона)
    showActingBasisDocumentFields() {
      const name = this.selectedContractTextType?.contract_text_type_name?.toLowerCase() || '';
      return name.includes('доверенност') || name.includes('талон');
    },
    // Подпись для поля номера
    actingBasisDocumentNumberLabel() {
      const name = this.selectedContractTextType?.contract_text_type_name?.toLowerCase() || '';
      return name.includes('талон') ? 'Номер талона' : 'Номер доверенности';
    },
    // Подпись для поля даты
    actingBasisDocumentDateLabel() {
      const name = this.selectedContractTextType?.contract_text_type_name?.toLowerCase() || '';
      return name.includes('талон') ? 'Дата талона' : 'Дата доверенности';
    },
    availableOkedyOptionsForSelect() {
      if (this.hasMultipleOkedyFromPartner && this.availableOkedyOptionsFromPartner.length > 0) {
        if (this.formData.sbs_vidy_deyatelnosti_id && this.formData.display_name) {
          const selectedExists = this.availableOkedyOptionsFromPartner.some(
            opt => opt.sbs_vidy_deyatelnosti_id === this.formData.sbs_vidy_deyatelnosti_id
          );

          if (!selectedExists) {
            return [
              {
                sbs_vidy_deyatelnosti_id: this.formData.sbs_vidy_deyatelnosti_id,
                display_name: this.formData.display_name
              },
              ...this.availableOkedyOptionsFromPartner
            ];
          }
        }

        return this.availableOkedyOptionsFromPartner;
      }

      return this.sbsVidyDeyatelnostiOptions;
    }
  },
  methods: {
    async initSbsFromLinkedPartner() {
      if (!this.formData.sbs_partner_id) return;
      const needSnr = !this.formData.sbs_snr_id;
      const needOked = !this.formData.sbs_vidy_deyatelnosti_id;
      if (!needSnr && !needOked) return;

      try {
        this.partnerSBSLoading = true;
        const response = await mapSBSPartner({ search_text: this.formData.sbs_partner_name || '' });
        const list = Array.isArray(response) ? response : [];
        const found = list.find(it => String(it.sbs_partner_id) === String(this.formData.sbs_partner_id));
        if (found) {
          // SNR
          if (needSnr && found.sbs_snr_id) {
            this.formData.sbs_snr_id = found.sbs_snr_id;
            const exists = this.sbsSnrOptions.some(opt => opt.sbs_spetsialnye_nalogovye_rezhimy_id === found.sbs_snr_id);
            if (!exists && found.sbs_snr_name) {
              this.sbsSnrOptions.push({
                sbs_spetsialnye_nalogovye_rezhimy_id: found.sbs_snr_id,
                naimenovanie: found.sbs_snr_name
              });
            }
          }
          // OKED
          if (needOked && found.sbs_vidy_deyatelnosti_id && Array.isArray(found.sbs_vidy_deyatelnosti_id) && found.sbs_vidy_deyatelnosti_id.length > 0) {
            if (found.sbs_vidy_deyatelnosti_id.length === 1) {
              const vidId = found.sbs_vidy_deyatelnosti_id[0];
              const vidName = found.vidy_deyatelnosti_name && found.vidy_deyatelnosti_name[0] ? found.vidy_deyatelnosti_name[0] : '';
              this.formData.sbs_vidy_deyatelnosti_id = vidId;
              this.formData.display_name = vidName;
              const exists = this.sbsVidyDeyatelnostiOptions.some(opt => opt.sbs_vidy_deyatelnosti_id === vidId);
              if (!exists && vidName) {
                this.sbsVidyDeyatelnostiOptions.unshift({
                  sbs_vidy_deyatelnosti_id: vidId,
                  display_name: vidName,
                  guid_oked_for_onec: found.vidy_deyatelnosti_guid && found.vidy_deyatelnosti_guid[0] ? found.vidy_deyatelnosti_guid[0] : null
                });
              }
              this.showMultipleOkedyWarning = false;
              this.availableOkedyOptionsFromPartner = [];
              this.hasMultipleOkedyFromPartner = false;
            } else {
              this.formData.sbs_vidy_deyatelnosti_id = '';
              this.formData.display_name = '';
              this.showMultipleOkedyWarning = true;
              this.hasMultipleOkedyFromPartner = true;
              this.availableOkedyOptionsFromPartner = found.sbs_vidy_deyatelnosti_id.map((id, idx) => ({
                sbs_vidy_deyatelnosti_id: id,
                display_name: found.vidy_deyatelnosti_name && found.vidy_deyatelnosti_name[idx] ? found.vidy_deyatelnosti_name[idx] : '',
                guid_oked_for_onec: found.vidy_deyatelnosti_guid && found.vidy_deyatelnosti_guid[idx] ? found.vidy_deyatelnosti_guid[idx] : null
              })).filter(opt => opt.display_name);
            }
          }
        }
      } finally {
        this.partnerSBSLoading = false;
      }
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    onContractTextTypeChange(value) {
      this.formData.contract_text_type_id = value;
      // При выборе "Устава" очищаем поля доверенности/талона
      const selectedOption = this.contractTextTypeOptionsWithCurrent.find(
        opt => opt.contract_text_type_id === value || String(opt.contract_text_type_id) === String(value)
      );
      const name = selectedOption?.contract_text_type_name?.toLowerCase() || '';
      if (!name.includes('доверенност') && !name.includes('талон')) {
        this.formData.acting_basis_document_number = '';
        this.formData.acting_basis_document_date = '';
      }
    },
    focusField(targetElement, qSelect, qField) {
      const input = targetElement.querySelector('input, textarea');
      
      if (qSelect || qField) {
        const selectElement = qSelect || qField;
        if (selectElement) {
          selectElement.focus();
          // Пытаемся открыть выпадающий список
          try {
            const clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true });
            selectElement.dispatchEvent(clickEvent);
          } catch (e) {
            console.log('Could not open select dropdown');
          }
        }
      } else if (input) {
        input.focus();
      }
    },
    validateRequiredFields() {
      const requiredFields = [
        { key: 'provider_name', ref: 'provider_name_ref' },
        { key: 'director_fio', ref: 'director_fio_ref' },
        { key: 'bin', ref: 'bin_ref' },
        { key: 'contract_text_type_id', ref: 'contract_text_type_id_ref' },
        { key: 'contragent_country_id', ref: 'contragent_country_id_ref' },
        { key: 'city_id', ref: 'city_id_ref' },
        { key: 'address', ref: 'address_ref' },
        { key: 'phone', ref: 'phone_ref' },
        { key: 'iik', ref: 'iik_ref' },
        { key: 'bank_name', ref: 'bank_name_ref' },
        { key: 'bik', ref: 'bik_ref' },
        { key: 'kbe', ref: 'kbe_ref' },
      ];

      for (const field of requiredFields) {
        const value = this.formData[field.key];
        const isEmpty = value === null || value === undefined || value === '' || 
                       (typeof value === 'string' && value.trim() === '');
        
        if (isEmpty) {
          // Прокручиваем к незаполненному полю
          this.$nextTick(() => {
            const refElement = this.$refs[field.ref];
            let elementToScroll = null;
            
            if (refElement) {
              // Если это массив, берем первый элемент
              const element = Array.isArray(refElement) ? refElement[0] : refElement;
              
              // Пытаемся получить DOM элемент разными способами
              if (element && element.$el) {
                elementToScroll = element.$el;
              } else if (element && element instanceof HTMLElement) {
                elementToScroll = element;
              } else if (element && element.$el && element.$el.$el) {
                elementToScroll = element.$el.$el;
              }
              
              if (elementToScroll) {
                // Для выпадающих списков находим сам элемент .q-select или .q-field
                const qSelect = elementToScroll.querySelector('.q-select');
                const qField = elementToScroll.querySelector('.q-field');
                const targetElement = qSelect || qField || elementToScroll;
                
                // Находим прокручиваемый контейнер модального окна
                let scrollContainer = null;
                
                // Ищем через closest от целевого элемента
                scrollContainer = targetElement.closest('.scrollbar__wrapper') ||
                                 targetElement.closest('.modal__wrapper') ||
                                 targetElement.closest('.q-card');
                
                // Если не нашли, ищем через document.querySelector
                if (!scrollContainer) {
                  scrollContainer = document.querySelector('.q-dialog .scrollbar__wrapper') ||
                                   document.querySelector('.q-dialog .modal__wrapper') ||
                                   document.querySelector('.q-dialog .q-card');
                }
                
                // Если все еще не нашли, ищем любой прокручиваемый родитель
                if (!scrollContainer) {
                  let parent = targetElement.parentElement;
                  while (parent && parent !== document.body) {
                    const style = window.getComputedStyle(parent);
                    const hasScroll = parent.scrollHeight > parent.clientHeight;
                    if ((style.overflowY === 'auto' || style.overflowY === 'scroll') && hasScroll) {
                      scrollContainer = parent;
                      break;
                    }
                    parent = parent.parentElement;
                  }
                }
                
                if (scrollContainer) {
                  // Получаем позиции элементов
                  const containerRect = scrollContainer.getBoundingClientRect();
                  const targetRect = targetElement.getBoundingClientRect();
                  
                  // Вычисляем позицию элемента относительно контейнера
                  const elementTopRelativeToContainer = targetRect.top - containerRect.top + scrollContainer.scrollTop;
                  
                  // Вычисляем желаемую позицию (с отступом сверху)
                  const offset = 80; // Отступ сверху в пикселях
                  const desiredScrollTop = Math.max(0, elementTopRelativeToContainer - offset);
                  
                  // Прокручиваем контейнер вручную с плавной анимацией
                  const startScrollTop = scrollContainer.scrollTop;
                  const distance = desiredScrollTop - startScrollTop;
                  
                  // Если расстояние небольшое, прокручиваем сразу
                  if (Math.abs(distance) < 10) {
                    scrollContainer.scrollTop = desiredScrollTop;
                    setTimeout(() => {
                      this.focusField(targetElement, qSelect, qField);
                    }, 100);
                  } else {
                    const duration = 600; // миллисекунды
                    const startTime = performance.now();
                    
                    const animateScroll = (currentTime) => {
                      const elapsed = currentTime - startTime;
                      const progress = Math.min(elapsed / duration, 1);
                      
                      // Используем easing функцию для плавности
                      const easeInOutCubic = progress < 0.5
                        ? 4 * progress * progress * progress
                        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
                      
                      scrollContainer.scrollTop = startScrollTop + distance * easeInOutCubic;
                      
                      if (progress < 1) {
                        requestAnimationFrame(animateScroll);
                      } else {
                        // После завершения прокрутки фокусируемся на поле
                        setTimeout(() => {
                          this.focusField(targetElement, qSelect, qField);
                        }, 150);
                      }
                    };
                    
                    requestAnimationFrame(animateScroll);
                  }
                } else {
                  // Если не нашли контейнер, используем стандартный способ
                  targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  setTimeout(() => {
                    this.focusField(targetElement, qSelect, qField);
                  }, 400);
                }
              }
            }
          });
          return false;
        }
      }

      return true;
    },
    async onSubmit() {
      // Проверяем обязательные поля перед отправкой
      if (!this.validateRequiredFields()) {
        return;
      }

      this.loading = true
      
      const submitData = { ...this.formData }
      
      // Формируем contract_text из трех полей
      if (submitData.contract_text_type_id) {
        const selectedTextType = this.contractTextTypeOptionsWithCurrent.find(
          option => option.contract_text_type_id === submitData.contract_text_type_id ||
            String(option.contract_text_type_id) === String(submitData.contract_text_type_id)
        )
        
        if (selectedTextType) {
          const typeName = selectedTextType.contract_text_type_name;
          const nameLower = typeName.toLowerCase();
          
          // Если выбрана доверенность или талон, формируем строку с номером и датой
          if (nameLower.includes('доверенност') || nameLower.includes('талон')) {
            let contractText = typeName;
            
            // Добавляем номер, если он есть
            if (submitData.acting_basis_document_number) {
              contractText += ` №${submitData.acting_basis_document_number}`;
            }
            
            // Добавляем дату, если она есть
            if (submitData.acting_basis_document_date) {
              const formattedDate = this.formatDateForContract(submitData.acting_basis_document_date);
              if (formattedDate) {
                contractText += ` от ${formattedDate}`;
              }
            }
            
            submitData.contract_text = contractText;
          } else {
            // Для Устава просто используем название
            submitData.contract_text = typeName;
          }
        }
      }
      
      // Удаляем временные поля из отправляемых данных
      delete submitData.acting_basis_document_number;
      delete submitData.acting_basis_document_date;
      delete submitData.contract_text_type_id;
      
      await this.data?.onSubmit(submitData)
      this.loading = false
    },
    // Форматирование даты для contract_text (формат: D.MM.YYYY)
    formatDateForContract(date) {
      if (!date) return '';
      try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';
        
        const day = d.getDate();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        
        return `${day}.${month}.${year}`;
      } catch (e) {
        return '';
      }
    },
    // Парсинг существующего contract_text для заполнения полей
    parseContractText(contractText, options) {
      if (!contractText) return;
      
      // Пытаемся найти точное совпадение
      let foundOption = options.find(
        option => option.contract_text_type_name === contractText
      );
      
      // Если не найдено, пытаемся найти по началу строки (для случаев с номером и датой)
      if (!foundOption) {
        // Ищем опцию, которая является началом contract_text
        foundOption = options.find(option => {
          const optionName = option.contract_text_type_name.toLowerCase();
          const contractTextLower = contractText.toLowerCase();
          return contractTextLower.startsWith(optionName);
        });
      }
      
      if (foundOption) {
        this.formData.contract_text_type_id = foundOption.contract_text_type_id;
        
        // Парсим номер и дату, если они есть
        const typeName = foundOption.contract_text_type_name;
        const nameLower = typeName.toLowerCase();
        
        // Если это доверенность или талон, парсим номер и дату
        if (nameLower.includes('доверенност') || nameLower.includes('талон')) {
          // Ищем номер после "№"
          const numberMatch = contractText.match(/№\s*([^\s]+)/);
          if (numberMatch) {
            this.formData.acting_basis_document_number = numberMatch[1];
          }
          
          // Ищем дату после "от"
          const dateMatch = contractText.match(/от\s+(\d{1,2}\.\d{2}\.\d{4})/);
          if (dateMatch) {
            // Преобразуем дату из формата D.MM.YYYY в формат для date picker
            const dateParts = dateMatch[1].split('.');
            if (dateParts.length === 3) {
              const year = dateParts[2];
              const month = dateParts[1];
              const day = dateParts[0];
              // Формат для date picker: YYYY-MM-DD
              this.formData.acting_basis_document_date = `${year}-${month}-${day}`;
            }
          }
        }
      } else {
        // Если значение не найдено в списке, создаем временный ID для отображения
        this.formData.contract_text_type_id = `temp_${contractText}`;
      }
    },
    async fetchCities() {
      this.cityOptions = await getCity();
    },
    async fetchCountries() {
      this.countryOptions = await getProviderCountry();
    },
    async fetchContragentType() {
      this.contragentTypeOptions = await getContragentType();
    },
    async fetchProviderType() {
      this.providerTypeOptions = await getProviderType();
    },
    async fetchSBSsnr() {
      this.sbsSnrOptions = await getSBSsnr();
    },
    async fetchContractTextType() {
      const res = await getContractTextType();
      this.contractTextTypeOptions = res || [];
    },
    partnerSBSSelectItem(value, obj) {
      if (!obj || obj === null || obj === undefined) {
        this.formData = {
          ...this.formData,
          sbs_partner_id: '',
          sbs_partner_name: '',
          sbs_snr_id: '',
          sbs_vidy_deyatelnosti_id: '',
          display_name: ''
        };
        this.showMultipleOkedyWarning = false;
        this.availableOkedyOptionsFromPartner = [];
        this.hasMultipleOkedyFromPartner = false;
      } else {
        this.formData = {
          ...this.formData,
          sbs_partner_id: obj.sbs_partner_id,
          sbs_partner_name: obj.naimenovanie
        };

        // Автозаполнение СНР из выбранного поставщика SBS
        if (obj.sbs_snr_id) {
          this.formData.sbs_snr_id = obj.sbs_snr_id;

          const snrExists = this.sbsSnrOptions.some(
            opt => opt.sbs_spetsialnye_nalogovye_rezhimy_id === obj.sbs_snr_id
          );

          if (!snrExists && obj.sbs_snr_name) {
            this.sbsSnrOptions.push({
              sbs_spetsialnye_nalogovye_rezhimy_id: obj.sbs_snr_id,
              naimenovanie: obj.sbs_snr_name
            });
          }
        }

        // Автозаполнение ОКЭД из выбранного поставщика SBS
        if (obj.sbs_vidy_deyatelnosti_id && Array.isArray(obj.sbs_vidy_deyatelnosti_id) && obj.sbs_vidy_deyatelnosti_id.length > 0) {
          if (obj.sbs_vidy_deyatelnosti_id.length === 1) {
            const vidDeyatId = obj.sbs_vidy_deyatelnosti_id[0];
            const vidDeyatName = obj.vidy_deyatelnosti_name && obj.vidy_deyatelnosti_name[0]
              ? obj.vidy_deyatelnosti_name[0]
              : '';

            this.formData.sbs_vidy_deyatelnosti_id = vidDeyatId;
            this.formData.display_name = vidDeyatName;

            const exists = this.sbsVidyDeyatelnostiOptions.some(
              opt => opt.sbs_vidy_deyatelnosti_id === vidDeyatId
            );

            if (!exists && vidDeyatName) {
              this.sbsVidyDeyatelnostiOptions.unshift({
                sbs_vidy_deyatelnosti_id: vidDeyatId,
                display_name: vidDeyatName,
                guid_oked_for_onec: obj.vidy_deyatelnosti_guid && obj.vidy_deyatelnosti_guid[0]
                  ? obj.vidy_deyatelnosti_guid[0]
                  : null
              });
            }
            this.showMultipleOkedyWarning = false;
            this.availableOkedyOptionsFromPartner = [];
            this.hasMultipleOkedyFromPartner = false;
          } else {
            // Если из SBS пришло несколько ОКЭД, выбор выполняется вручную из ограниченного списка
            this.formData.sbs_vidy_deyatelnosti_id = '';
            this.formData.display_name = '';
            this.showMultipleOkedyWarning = true;
            this.hasMultipleOkedyFromPartner = true;
            this.availableOkedyOptionsFromPartner = obj.sbs_vidy_deyatelnosti_id.map((id, index) => ({
              sbs_vidy_deyatelnosti_id: id,
              display_name: obj.vidy_deyatelnosti_name && obj.vidy_deyatelnosti_name[index]
                ? obj.vidy_deyatelnosti_name[index]
                : '',
              guid_oked_for_onec: obj.vidy_deyatelnosti_guid && obj.vidy_deyatelnosti_guid[index]
                ? obj.vidy_deyatelnosti_guid[index]
                : null
            })).filter(opt => opt.display_name);
          }
        }
      }
    },
    async partnerSBSFilterFunc(value) {
      this.formData.sbs_partner_name = value;

      if (!value) {
        this.formData.sbs_partner_id = '';
        this.formData.sbs_partner_name = '';
        this.partnerSBSOptions = [];
        this.partnerSBSLoading = false;
        return;
      }

      if (value?.length >= 3) {
        this.partnerSBSLoading = true;
        let body = { search_text: value }
        const response = await mapSBSPartner(body);
        this.partnerSBSOptions = response || [];
        this.partnerSBSLoading = false;
      } else {
        this.partnerSBSOptions = [];
        this.partnerSBSLoading = false;
      }
    },
    async sbsVidyDeyatelnostiFilterFunc(val, update) {
      update(async (value) => {
        if (!val || val.trim() === '') {
          this.sbsVidyDeyatelnostiLoading = true
          let body = { search_text: '' }
          const res = await mapSBSVidyDeyatelnosti(body);
          this.sbsVidyDeyatelnostiLoading = false;
          this.sbsVidyDeyatelnostiOptions = res || [];
          return;
        }
        this.sbsVidyDeyatelnostiLoading = true
        let body = { search_text: val }
        const res = await mapSBSVidyDeyatelnosti(body);
        this.sbsVidyDeyatelnostiLoading = false;
        this.sbsVidyDeyatelnostiOptions = res || [];
      });
    },
    sbsVidyDeyatelnostiChange(value, row) {
      if (!row || !value || !row.display_name) {
        this.formData = {
          ...this.formData,
          sbs_vidy_deyatelnosti_id: null,
          display_name: ''
        };
        if (this.hasMultipleOkedyFromPartner) {
          this.showMultipleOkedyWarning = true;
        }
      } else {
        this.formData = {
          ...this.formData,
          sbs_vidy_deyatelnosti_id: row.sbs_vidy_deyatelnosti_id,
          display_name: row.display_name
        };
        this.showMultipleOkedyWarning = false;
      }
    },
    async loadSBSVidyDeyatelnosti() {
      this.sbsVidyDeyatelnostiLoading = true
      let body = { search_text: '' }
      const res = await mapSBSVidyDeyatelnosti(body);
      this.sbsVidyDeyatelnostiLoading = false
      this.sbsVidyDeyatelnostiOptions = res || [];
      if (this.formData.sbs_vidy_deyatelnosti_id && this.data?.body?.display_name) {
        const exists = this.sbsVidyDeyatelnostiOptions.some(opt => opt.sbs_vidy_deyatelnosti_id === this.formData.sbs_vidy_deyatelnosti_id);
        if (!exists) {
          this.sbsVidyDeyatelnostiOptions.unshift({
            sbs_vidy_deyatelnosti_id: this.formData.sbs_vidy_deyatelnosti_id,
            display_name: this.data.body.display_name,
            kod_oked: this.data.body.kod_oked,
            naimenovanie: this.data.body.naimenovanie_oked,
            guid_oked_for_onec: this.data.body.guid_oked_for_onec
          });
        }
      }
    },
  },
  mounted() {
    this.fetchCities();
    this.$watch('cityOptions', (newOptions) => {
      if (newOptions.length && !this.formData.city_id) {
        this.formData.city_id = newOptions[0].city_id;
      }
    });
    this.fetchCountries();
    this.$watch('countryOptions', (newOptions) => {
      if (newOptions.length && !this.formData.contragent_country_id) {
        this.formData.contragent_country_id = newOptions[0].contragent_country_id;
      }
    });
    this.fetchContragentType();
    this.fetchProviderType();
    this.fetchSBSsnr();
    this.loadSBSVidyDeyatelnosti();
    this.fetchContractTextType();
    this.$watch('contractTextTypeOptions', (newOptions) => {
      // Если есть contract_text, но нет contract_text_type_id, парсим его
      if (newOptions.length && this.formData.contract_text && !this.formData.contract_text_type_id) {
        this.parseContractText(this.formData.contract_text, newOptions);
      }
    });
    // Если уже есть привязка к SBS и СНР/ОКЭД не выбраны — ограничим варианты из SBS
    this.initSbsFromLinkedPartner();
  }
}
</script>

<style scoped lang="scss">
.form-section {
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  &__title {
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1976d2;
    border-bottom: 2px solid #e3f2fd;
  }
}

.form {
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: 6fr 6fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 12fr;
  }

  &__item {
    flex: 1 1 45%;

    &--full {
      grid-column: 1 / -1;
    }
  }
}

.okedy-warning-text {
  margin-top: 8px;
  font-size: 12px;
  color: #d32f2f;
  line-height: 1.4;
  padding: 4px 0;
}
</style>
